import { defineComponent } from "vue";
import Dropdown from "@/components/primitives/dropdown/Dropdown";
import IconButton from "@/components/ui/icon-button/IconButton";
import Icon from "@/components/ui/icon/Icon";
import { getLocale, setLocale } from "@/services/i18n";

export default defineComponent({
  name: "ThemeSwitcher",
  setup() {
    const options = [
      {
        value: "pt",
        label: "Português",
      },
      {
        value: "en",
        label: "English",
      },
    ] as const;

    function isActive(option: (typeof options)[number]) {
      return getLocale() === option.value;
    }

    return () => (
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <IconButton
            label="Language"
            icon={"lucide:languages"}
            variant="ghost"
            class="shrink-0"
            size="sm"
          />
        </Dropdown.Trigger>
        <Dropdown.Content avoidCollisions sideOffset={8} align="end">
          <Dropdown.Group>
            {options.map((option) => (
              <Dropdown.Item
                class="w-32"
                key={option.value}
                onSelect={() => setLocale(option.value)}
              >
                {option.label}
                {isActive(option) && <Icon icon="radix-icons:dot-filled" class="ml-auto h-4 w-4" />}
              </Dropdown.Item>
            ))}
          </Dropdown.Group>
        </Dropdown.Content>
      </Dropdown.Root>
    );
  },
});
